export default {
  taskDetail: '/v3/grow/taskDetail'
}
